import Drawer from '@mui/material/Drawer';
import Toolbar from '@mui/material/Toolbar';
import { alpha, Box, Button, Collapse, Divider, Stack, Typography, useTheme } from '@mui/material';
import routes from '../../config/routes';
import { Link, useLocation } from 'react-router-dom';
import { useUserContext } from '../../App';
import Icon from './Icon';
import { useState } from 'react';

const contactLinks = [
    {
        icon: 'Telegram',
        name: 'telegram',
    },

    {
        icon: 'Instagram',
        name: 'instagram',
    },
    {
        icon: 'Discord',
        name: 'discord',
    },
    {
        icon: 'Twitter',
        name: 'twitter',
    },
    {
        icon: 'Tik',
        link: 'tiktok',
    },
];

const navItems = [
    {
        type: 'header',
        name: 'MAIN MENU',
    },
    {
        name: 'Dashboard',
        icon: 'house-2',
        link: routes.HOME,
    },

    {
        name: 'Marketing',
        icon: 'home',
        link: '/marketing',
    },
    {
        name: 'Users',
        icon: 'people',
        link: '/users',
    },
    {
        name: 'Orders',
        icon: 'document-text',
        link: '/orders',
    },
    {
        name: 'Veeqo Orders',
        icon: 'receipt-2',
        link: '/pending-orders',
    },
    {
        name: 'International Orders',
        icon: 'box',
        link: '/international-orders',
    },
    {
        name: 'Invoices',
        icon: 'receipt-2',
        link: '/invoices',
    },
    {
        name: 'Scans',
        icon: 'ticket',
        link: '/scans',
    },
    {
        name: 'Bulk Orders',
        icon: 'document-text',
        subItems: [
            {
                name: 'Bulk Orders',
                link: '/bulk-orders',
            },
            {
                name: 'Amazon Orders',
                link: '/amazon-orders',
            },
            {
                name: 'New Amazon Orders',
                link: '/new-amazon-orders',
            },
        ],
    },
    {
        name: 'Transactions',
        icon: 'receipt-2',
        link: '/transactions',
    },
    {
        type: 'header',
        name: 'SUPPORT',
    },
    {
        name: 'Tickets',
        icon: 'ticket',
        link: '/tickets',
    },
    {
        name: 'Workers',
        icon: 'people',
        link: '/workers',
    },
    {
        type: 'header',
        name: 'OPTIONS',
    },
    {
        name: 'Label Pricing',
        icon: 'dollar-circle',
        link: '/labelPricing',
    },
    {
        name: 'Int Label Pricing',
        icon: 'box',
        link: '/labelPricing-international',
    },
    {
        name: 'Scan Pricing',
        icon: 'ticket',
        link: '/scan-pricing',
    },
    // {
    //     name: 'Coupons',
    //     icon: 'ticket',
    //     link: '/coupons',
    // },
    {
        name: 'Crypto Settings',
        icon: 'coin',
        link: '/crypto-settings',
    },

    {
        name: 'Website',
        icon: 'code-circle',
        link: '/website',
    },
];

const navItemsworker = [
    // {
    //     name: 'Orders',
    //     icon: 'document-text',
    //     link: '/orders',
    // },
    {
        name: 'International Orders',
        icon: 'document-text',
        link: '/international-orders',
    },
];
const NavItem = ({ name, type, icon, link, active, toggle, miniDrawer, contact, subItems }) => {
    const theme = useTheme();
    const location = useLocation();
    const [open, setOpen] = useState(false);

    const hasActiveSubItem = subItems?.some((item) => item.link === location.pathname);
    const isExpanded = open || hasActiveSubItem;

    if (type) {
        return miniDrawer ? (
            ''
        ) : (
            <Typography variant="body2" color={alpha('#fff', 0.4)} fontWeight={700} pt={1}>
                {name}
            </Typography>
        );
    }

    if (subItems) {
        return (
            <Box>
                <Stack
                    direction="row"
                    spacing={1}
                    alignItems="center"
                    justifyContent={miniDrawer ? 'center' : 'flex-start'}
                    onClick={() => setOpen(!open)}
                    sx={{
                        '&:hover': {
                            bgcolor: alpha(theme.palette.primary.main, 0.1),
                            color: theme.palette.primary.main,
                        },
                        bgcolor: hasActiveSubItem && alpha(theme.palette.primary.main, 0.1),
                        transitionDuration: '0.3s',
                        p: 1,
                        borderRadius: 1,
                        cursor: 'pointer',
                    }}>
                    <Icon path={`${hasActiveSubItem ? 'bulk' : 'outline'}/${icon}`} />
                    {!miniDrawer && (
                        <>
                            <Typography sx={{ fontWeight: hasActiveSubItem ? 600 : 500, fontSize: 15, flex: 1 }}>
                                {name}
                            </Typography>
                            <Typography sx={{ fontSize: 12 }}>{isExpanded ? '▼' : '▶'}</Typography>
                        </>
                    )}
                </Stack>
                {!miniDrawer && (
                    <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                        <Stack spacing={0.5} pl={4} pt={0.5}>
                            {subItems.map((item) => (
                                <Link key={item.link} to={item.link} onClick={toggle}>
                                    <Typography
                                        sx={{
                                            fontWeight: location.pathname === item.link ? 600 : 500,
                                            fontSize: 14,
                                            p: 0.8,
                                            borderRadius: 1,
                                            color: location.pathname === item.link ? 'primary.main' : 'inherit',
                                            bgcolor:
                                                location.pathname === item.link &&
                                                alpha(theme.palette.primary.main, 0.1),
                                            '&:hover': {
                                                bgcolor: alpha(theme.palette.primary.main, 0.1),
                                                color: theme.palette.primary.main,
                                            },
                                            transitionDuration: '0.3s',
                                        }}>
                                        {item.name}
                                    </Typography>
                                </Link>
                            ))}
                        </Stack>
                    </Collapse>
                )}
            </Box>
        );
    }

    return (
        <Link to={link} onClick={toggle}>
            <Stack
                direction="row"
                spacing={1}
                alignItems="center"
                justifyContent={miniDrawer ? 'center' : 'flex-start'}
                sx={{
                    '&:hover': {
                        bgcolor: alpha(theme.palette.primary.main, 0.1),
                        color: theme.palette.primary.main,
                    },
                    bgcolor: active && alpha(theme.palette.primary.main, 0.1),
                    transitionDuration: '0.3s',
                    p: 1,
                    borderRadius: 1,
                }}>
                <Icon path={`${active ? 'bulk' : 'outline'}/${icon}`} />
                {!miniDrawer && <Typography sx={{ fontWeight: active ? 600 : 500, fontSize: 15 }}>{name}</Typography>}
            </Stack>
        </Link>
    );
};

const DrawerContent = ({ toggle, miniDrawer, contact }) => {
    const location = useLocation();
    const theme = useTheme();
    const { user } = useUserContext();

    return (
        <Stack justifyContent={'space-between'} sx={{ height: '100%' }}>
            <div>
                <Toolbar sx={{ px: 3 }}>
                    <img
                        src={`/assets/images/logo${miniDrawer ? '' : ''}.svg`}
                        alt="logo"
                        className={miniDrawer ? 'mini-logo' : 'logo'}
                    />
                </Toolbar>

                <Stack spacing={0.7} px={3} pb={2}>
                    <Stack spacing={1} sx={{ display: miniDrawer ? 'none' : 'flex' }}>
                        <Divider sx={{ bgcolor: '#ececec' }} />
                        <Stack spacing={1.4} sx={{ py: 0.7 }}>
                            <Button
                                sx={{
                                    justifyContent: 'flex-start',
                                    color: 'secondary.main',
                                    fontSize: 13,
                                    px: 1.5,
                                    fontWeight: user?.isPremium ? 700 : 500,
                                    gap: 0.7,
                                    backgroundColor: alpha(theme.palette.secondary.main, 0.3),
                                    border: '1px solid',
                                    borderColor: theme.palette.secondary.main,
                                }}>
                                <Icon
                                    path="crown"
                                    style={{
                                        width: '1.4rem',
                                    }}
                                />{' '}
                                Admin
                            </Button>
                        </Stack>
                        <Divider sx={{ bgcolor: '#ececec' }} />
                    </Stack>
                    {user.role !== 'admin'
                        ? navItemsworker.map((navItem) => (
                              <NavItem
                                  {...navItem}
                                  toggle={toggle}
                                  r={theme.shape.borderRadius}
                                  active={navItem.link === location.pathname}
                                  miniDrawer={miniDrawer}
                              />
                          ))
                        : navItems.map((navItem) => (
                              <NavItem
                                  {...navItem}
                                  toggle={toggle}
                                  r={theme.shape.borderRadius}
                                  active={navItem.link === location.pathname}
                                  miniDrawer={miniDrawer}
                              />
                          ))}
                </Stack>
            </div>

            <Stack spacing={1} px={miniDrawer ? 2 : 3} pb={1}>
                {!miniDrawer && (
                    <Link to="/tos">
                        <Typography fontWeight={600} textAlign="center" variant="body2">
                            Terms of Service | Privacy Policy
                        </Typography>
                    </Link>
                )}
                <Stack direction={'row'} justifyContent="space-around" alignItems={'center'} flexWrap="wrap" gap={1}>
                    {contactLinks.map((c) => (
                        <a href={contact[c.name] || '#'} target="_blank" rel="noreferrer">
                            <img
                                src={`/assets/images/${c.icon + (theme.palette.mode === 'dark' ? '1' : '')}.svg`}
                                alt={c.DrawerContenticon}
                            />
                        </a>
                    ))}
                </Stack>
            </Stack>
        </Stack>
    );
};

const SideBar = ({ drawerWidth, window, toggle, mobileOpen, miniDrawer, contact, interOrderInfo }) => {
    const container = window !== undefined ? () => window().document.body : undefined;

    return (
        <Box
            component="nav"
            sx={{
                width: { sm: drawerWidth },
                flexShrink: { sm: 0 },
            }}>
            <Drawer
                container={container}
                variant="temporary"
                open={mobileOpen}
                onClose={toggle}
                ModalProps={{
                    keepMounted: true, // Better open performance on mobile.
                }}
                sx={{
                    display: { xs: 'block', sm: 'none' },
                    '& .MuiDrawer-paper': {
                        boxSizing: 'border-box',
                        width: drawerWidth,
                        borderRight: 'solid 2px rgba(255,255,255,0.1)',
                    },
                }}>
                <DrawerContent toggle={toggle} contact={contact} />
            </Drawer>
            <Drawer
                sx={{
                    display: { xs: 'none', sm: 'block' },
                    '& .MuiDrawer-paper': {
                        width: drawerWidth,
                        boxSizing: 'border-box',
                        borderRight: 'solid 2px rgba(255,255,255,0.1)',
                        transition: 'width 0.3s',
                        overflow: 'auto',
                    },
                }}
                variant="permanent"
                open>
                <DrawerContent miniDrawer={miniDrawer} contact={contact} />
            </Drawer>
        </Box>
    );
};

export default SideBar;
